// Student dashboard (home of a student account or of a parent in student mode).
const en = {
  studentHome: {
    greeting: "Hello, {{name}}!",
    subtitle: "Here is what's coming up for you.",
    lessons: {
      title: "My next lessons",
      viewAll: "All my lessons",
      empty: "No lessons planned for now.",
      next: "Next lesson",
      now: "Now",
      today: "Today",
      tomorrow: "Tomorrow",
      join: "Join the lesson",
      joinSoon: "The link opens {{time}} before the lesson",
      noLink: "Link coming soon",
      with: "with {{name}}",
      minutes: "{{count}} min",
    },
    homework: {
      title: "My homework",
      viewAll: "All my homework",
      empty: "No homework for now. Well done!",
      toDo: "{{count}} to do",
      due: "Due {{date}}",
      noDue: "No due date",
      late: "Late",
      submitted: "Sent · waiting for correction",
      reviewed: "Corrected",
      score: "Corrected · {{score}}/{{max}}",
      start: "Start",
      view: "View",
    },
  },
};

const fr = {
  studentHome: {
    greeting: "Bonjour, {{name}} !",
    subtitle: "Voici ce qui t'attend.",
    lessons: {
      title: "Mes prochains cours",
      viewAll: "Tous mes cours",
      empty: "Aucun cours prévu pour le moment.",
      next: "Prochain cours",
      now: "En ce moment",
      today: "Aujourd'hui",
      tomorrow: "Demain",
      join: "Rejoindre le cours",
      joinSoon: "Le lien s'ouvre {{time}} avant le cours",
      noLink: "Lien bientôt disponible",
      with: "avec {{name}}",
      minutes: "{{count}} min",
    },
    homework: {
      title: "Mes devoirs",
      viewAll: "Tous mes devoirs",
      empty: "Aucun devoir pour le moment. Bravo !",
      toDo: "{{count}} à faire",
      due: "À rendre {{date}}",
      noDue: "Pas de date limite",
      late: "En retard",
      submitted: "Envoyé · en attente de correction",
      reviewed: "Corrigé",
      score: "Corrigé · {{score}}/{{max}}",
      start: "Commencer",
      view: "Voir",
    },
  },
};

const ar = {
  studentHome: {
    greeting: "مرحبًا، {{name}}!",
    subtitle: "هذا ما ينتظرك.",
    lessons: {
      title: "حصصي القادمة",
      viewAll: "كل حصصي",
      empty: "لا توجد حصص مبرمجة حاليًا.",
      next: "الحصة القادمة",
      now: "الآن",
      today: "اليوم",
      tomorrow: "غدًا",
      join: "الانضمام إلى الحصة",
      joinSoon: "يُفتح الرابط قبل الحصة بـ {{time}}",
      noLink: "الرابط قريبًا",
      with: "مع {{name}}",
      minutes: "{{count}} دقيقة",
    },
    homework: {
      title: "واجباتي",
      viewAll: "كل واجباتي",
      empty: "لا توجد واجبات حاليًا. أحسنت!",
      toDo: "{{count}} للإنجاز",
      due: "التسليم {{date}}",
      noDue: "بدون موعد تسليم",
      late: "متأخر",
      submitted: "أُرسل · في انتظار التصحيح",
      reviewed: "مصحّح",
      score: "مصحّح · {{score}}/{{max}}",
      start: "ابدأ",
      view: "عرض",
    },
  },
};

const studentHomeTranslations = { en, fr, ar };

export default studentHomeTranslations;
